import type { DigAppState } from "@/__main__/app-state.mjs";
import {
  __ONLY_WRITE_STATE_FROM_ACTIONS as writeState,
  MAX_RECENT_PATHS,
  recentlyPersistedPaths,
} from "@/__main__/app-state.mjs";
import { isVolatile } from "@/__main__/constants.mjs";
import {
  applyIsInitial,
  assignInitialPaths,
} from "@/__main__/initial-state.mjs";
import digPath from "@/util/dig-path.mjs";
import { CONFIG } from "@/util/state-cleanup.mjs";

/**
 * The officially sanctioned way for feature modules to add initial paths to app state 😎
 *
 * @param path The path to add to the app state.
 */
function addInitialPath<const P extends readonly PropertyKey[]>(
  path: P,
  obj: DigAppState<P>,
): void {
  // Clear previously persisted paths before adding.
  for (
    let i = Math.max(0, recentlyPersistedPaths.length - MAX_RECENT_PATHS);
    i < recentlyPersistedPaths.length;
    i++
  ) {
    if (!path.every((j, k) => j === recentlyPersistedPaths?.[i]?.[k])) continue;
    delete recentlyPersistedPaths[i];
  }

  applyIsInitial(obj);
  obj[isVolatile] = true;

  const [target, key] = digPath(path, writeState);
  target[key] = obj;

  assignInitialPaths(CONFIG.INITIAL_PATHS, obj, path);
}

export default addInitialPath;
